import queryString from 'querystring';

import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";


let redux = reduxCreator.type('USER_TOP_PHOTOS').plugin(axiosPlugin, {template: "array"});

let fetchUserTopPhotosAction = redux.fetchActionGet();

export const fetchUserTopPhotos = (userId, query = {}) => fetchUserTopPhotosAction(`/users/${userId}/best-medias?${queryString.stringify(query)}`);
export const resetUserTopPhotos = () => redux.actions.reset();

export const userTopPhotos = redux.reducer();